import { useForm, Link } from '@inertiajs/react'
import AppLayout from '../../components/AppLayout'

export default function EvaluationCriteriaShow({ criterion, versions }) {
  const { data, setData, patch, processing, errors } = useForm({
    weight_delivery: criterion.weight_delivery,
    weight_appeal:   criterion.weight_appeal,
    threshold:       criterion.threshold,
    upper_limit:     criterion.upper_limit,
    change_reason:   '',
  })

  const submit = (e) => {
    e.preventDefault()
    patch(`/evaluation_criteria/${criterion.id}`)
  }

  return (
    <AppLayout title={criterion.name}>
      <div style={{ marginBottom: '8px' }}>
        <Link href="/evaluation_criteria" style={{ color: '#4338ca', textDecoration: 'none', fontSize: '13px' }}>
          ← 評価指標マスタ
        </Link>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div>
          <div style={{ background: 'white', borderRadius: '10px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', marginBottom: '20px' }}>
            <h2 style={{ fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '12px' }}>指標情報</h2>
            <dl style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '6px 16px', fontSize: '12px' }}>
              <dt style={dtStyle}>カテゴリ</dt><dd style={ddStyle}>{criterion.category}</dd>
              <dt style={dtStyle}>キー</dt><dd style={ddStyle}><code style={{ fontSize: '11px' }}>{criterion.key}</code></dd>
              <dt style={dtStyle}>加減点</dt>
              <dd style={ddStyle}>
                <span style={{
                  padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600,
                  background: criterion.direction === 'positive' ? '#dcfce7' : '#fee2e2',
                  color: criterion.direction === 'positive' ? '#166534' : '#991b1b'
                }}>
                  {criterion.direction === 'positive' ? '🔼 加点' : '🔻 減点'}
                </span>
              </dd>
              {criterion.description && (
                <>
                  <dt style={dtStyle}>説明</dt>
                  <dd style={{ ...ddStyle, gridColumn: '2', color: '#64748b' }}>{criterion.description}</dd>
                </>
              )}
            </dl>
          </div>

          <div style={{ background: 'white', borderRadius: '10px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
            <h2 style={{ fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '16px' }}>パラメータ編集</h2>
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <Field label="閾値" value={data.threshold} onChange={v => setData('threshold', v)} error={errors.threshold} />
                <Field label="上限値" value={data.upper_limit} onChange={v => setData('upper_limit', v)} error={errors.upper_limit} />
                <Field label="重み（お届け）" value={data.weight_delivery} onChange={v => setData('weight_delivery', v)} error={errors.weight_delivery} />
                <Field label="重み（魅力）" value={data.weight_appeal} onChange={v => setData('weight_appeal', v)} error={errors.weight_appeal} />
              </div>
              <div>
                <label style={labelStyle}>変更理由</label>
                <input
                  type="text"
                  value={data.change_reason}
                  onChange={e => setData('change_reason', e.target.value)}
                  style={inputStyle}
                  placeholder="変更理由を記載（履歴に残ります）"
                />
              </div>
              <button type="submit" disabled={processing} style={{
                background: '#4338ca', color: 'white', border: 'none',
                padding: '8px 20px', borderRadius: '6px', fontSize: '13px',
                fontWeight: 600, cursor: 'pointer', alignSelf: 'flex-start'
              }}>
                {processing ? '保存中...' : '保存する'}
              </button>
            </form>
          </div>
        </div>

        <div>
          <h2 style={{ fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '8px' }}>変更履歴</h2>
          {versions.length === 0 ? (
            <div style={{ background: 'white', borderRadius: '10px', padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
              変更履歴はありません
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {versions.map(v => (
                <div key={v.id} style={{ background: 'white', borderRadius: '8px', padding: '12px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', fontSize: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span style={{ color: '#64748b' }}>{v.changed_by || '—'}</span>
                    <span style={{ color: '#94a3b8' }}>{new Date(v.created_at).toLocaleString('ja-JP')}</span>
                  </div>
                  {v.change_reason && <p style={{ color: '#475569', marginBottom: '6px' }}>{v.change_reason}</p>}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                    <DiffRow label="閾値" before={v.threshold_before} after={v.threshold_after} />
                    <DiffRow label="上限" before={v.upper_limit_before} after={v.upper_limit_after} />
                    <DiffRow label="重み(お届)" before={pct(v.weight_delivery_before)} after={pct(v.weight_delivery_after)} />
                    <DiffRow label="重み(魅力)" before={pct(v.weight_appeal_before)} after={pct(v.weight_appeal_after)} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  )
}

function Field({ label, value, onChange, error }) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      <input
        type="number" step="0.01" value={value}
        onChange={e => onChange(parseFloat(e.target.value))}
        style={{ ...inputStyle, borderColor: error ? '#dc2626' : '#e2e8f0' }}
      />
      {error && <p style={{ color: '#dc2626', fontSize: '11px', marginTop: '2px' }}>{error}</p>}
    </div>
  )
}

function DiffRow({ label, before, after }) {
  const changed = String(before) !== String(after)
  return (
    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <span style={{ color: '#94a3b8', minWidth: '56px' }}>{label}</span>
      <span style={{ color: changed ? '#64748b' : '#cbd5e1', textDecoration: changed ? 'line-through' : 'none' }}>{before}</span>
      {changed && <span style={{ color: '#166534', fontWeight: 600 }}>→ {after}</span>}
    </div>
  )
}

const pct = v => v != null ? `${(v * 100).toFixed(0)}%` : '—'
const dtStyle = { color: '#94a3b8', fontWeight: 500, whiteSpace: 'nowrap' }
const ddStyle = { color: '#334155', margin: 0 }
const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#334155', marginBottom: '4px' }
const inputStyle = { width: '100%', padding: '7px 10px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '12px', boxSizing: 'border-box' }
